import { callApi } from '@/api/apibase'

export const getAllowedOrganisations = function () {
  let headers = {
    'CriiptoJwtToken': localStorage.getItem('criiptoJwtToken'),
  }
  return callApi('GET', `/api/external/greencourse/GetAllowedOrganisationsBySsn`, null, headers)
}
